export default __webpack_public_path__ + "static/media/verify.accdb1b9.svg";